var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Dashboard',{staticClass:"full-height",staticStyle:{"height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }